import { BaseApiUrl } from '../../../configVariables';
import { TableContinuationToken } from '../../../model';
import apiClient from '../../../utils/apiClient';
import IConnectToTeam from '../../../model/IConnectToTeam';
import { AutoReplyMessageType } from '../../../model/AutoReplyMessageType';

export interface AutoReplyResponse {
    search: string;
    items: IConnectToTeam[];
    nextPageToken: TableContinuationToken;
}

export interface UpdateAutoReplyRequest {
    rowKey: string;
    autoReply?: string;
    closedConnectionReply?: string;
    messageType: AutoReplyMessageType;
}

export const fetchAutoReplies = async (
    query: string = ''
): Promise<AutoReplyResponse> => {
    const url = `${BaseApiUrl}/appsettings/autoreplies${query}`;
    const result = await apiClient.get<AutoReplyResponse>(url);
    return result.data;
};

export const updateAutoReply = async (
    data: UpdateAutoReplyRequest
): Promise<IConnectToTeam> => {
    const url = `${BaseApiUrl}/appsettings/autoreplies`;
    const result = await apiClient.post<IConnectToTeam, UpdateAutoReplyRequest>(
        url,
        data
    );
    return result.data;
};
